// extracted by mini-css-extract-plugin
export var measureBox = "_3m-0";